module.exports = "<form [formGroup]=\"form\" novalidate class=\"form-horizontal\">\n  <div class=\"form-group\">\n    <label class=\"control-label col-xs-3\">日期区间</label>\n    <div class=\"col-xs-6\">\n      <my-date-range-picker [options]=\"data.options\" formControlName=\"dateRange\">\n      </my-date-range-picker>\n    </div>\n    <div class=\"col-xs-3\">\n      <button class=\"btn btn-primary\" (click)=\"submitDateRange()\">查看</button>\n    </div>\n  </div>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/date-range/date-range.com.html
// module id = ./src/app/modules/shared/date-range/date-range.com.html
// module chunks = main